import { Button, Drawer, DrawerBody, DrawerFooter, IOption } from "../../";
import { useTranslation } from "react-i18next";
import { forwardRef, useImperativeHandle, useState } from "react";
import { ETypeColumn, IFilterProps, OperatorFilterStringEnums } from "./Model.ts";
import {
  FilterActionWrapper,
  FormListWrapper,
} from "@/DependenciesV9/DataTable/Filter/Style.ts";
import { IFilterQuery } from "@/DependenciesV9/DataTable/Model.ts";
import FormFilter from "@/DependenciesV9/DataTable/Filter/FormFilter";
import { Add16Regular } from "@fluentui/react-icons";
import { cloneDeep } from "lodash";
import { FilterType } from "../Enums/TableEnum.ts";

export const defaultOperator = (type: string | string): string => {
  switch (type) {
    case ETypeColumn.DATE:
    case ETypeColumn.NUMBER:
      return String(OperatorFilterStringEnums.Equal);
    default:
      return String(OperatorFilterStringEnums.Contain);
  }
};

export const defaultValueFilter = (type: ETypeColumn | string): string | number | Date => {
  switch (type) {
    case ETypeColumn.DATE: {
      const date: Date = new Date();
      return date;
    }
    case ETypeColumn.NUMBER:
      return 0;
    default:
      return "";
  }
};

const Filter = forwardRef((props: IFilterProps, ref) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [filtersQuery, setFiltersQuery] = useState<IFilterQuery[]>([]);

  const onOpenFilter = (filters: IFilterQuery[]) => {
    setFiltersQuery(filters);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  useImperativeHandle(ref, () => ({
    onOpenFilter,
  }));

  const onChange = (filterQuery: IFilterQuery, index: number) => {
    const filterQueryClone = cloneDeep(filtersQuery);
    filterQueryClone[index] = filterQuery;
    setFiltersQuery(filterQueryClone);
  }

  console.log("filtersQuery", filtersQuery);
  

  const optionsDropdown: IOption[] = (props.columns || []).map((column) => ({
    value: column.key,
    text: column.name,
  }));

  const renderFormList = () => {
    const selectedColumns = filtersQuery.map((filter => filter.key));
    return filtersQuery.map((filter, index) => {
      const workingColumn = props.columns?.find(
        (column) => column.key === filter.key
      );
      return (
        <FormFilter
          key={index}
          options={optionsDropdown}
          theme={props.theme}
          filterQuery={filter}
          workingColumn={workingColumn}
          indexFilter={index}
          onChange={onChange}
          selectedColumns={selectedColumns}
          columnsDefault={props.columns}
        />
      );
    });
  };

  const addMore = () => {
    const filterQueryClone = cloneDeep(filtersQuery);
    for (let index = 0; index < (props.columns || []).length; index++) {
      if (
        props.columns &&
        props.columns[index] &&
        (!filterQueryClone.length ||
          !filterQueryClone
            .map((filter: IFilterQuery) => filter.key)
            .includes(props.columns[index].key || ""))
      ) {
        const item: IFilterQuery = {
          key: props.columns[index].key,
          value: defaultValueFilter(props.columns && props.columns[index] ? props.columns[index].data : ""),
          operator: defaultOperator(props.columns && props.columns[index] ? props.columns[index].data : ""),
          order: "",
          type: FilterType.Filter,
          childQuery: props.columns[index].queryKey,
        };
        filterQueryClone.push(item);
        break;
      }
    }
    setFiltersQuery(filterQueryClone);
  };

  return (
    <Drawer
      open={isOpen}
      headerText={t("Filter by")}
      size="medium"
      rcName="filter_table"
      onDismiss={handleClose}
    >
      <DrawerBody>
        <FormListWrapper>
          {renderFormList()}
          <div className="add-more">
            <Button icon={<Add16Regular />} appearance="transparent" onClick={addMore}>
              Add more
            </Button>
          </div>
        </FormListWrapper>
      </DrawerBody>
      <DrawerFooter>
        <FilterActionWrapper className="FilterActionWrapper">
          <Button appearance="primary" onClick={handleClose}>
            {t("Apply")}
          </Button>
          <Button onClick={handleClose}>{t("Clear all")}</Button>
        </FilterActionWrapper>
      </DrawerFooter>
    </Drawer>
  );
});

export default Filter;
